<template>
  <div class="a7-painel-parameter">
    <gw-filter-band v-model="filterParams">
      <gw-text-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroNomeIndicador')" property-name="nome"/>
      <a7-indicador-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroIndicador')" property-name="indicador"/>
      <gw-possible-value-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroTipoAvaliacao')"
        property-name="avaliacao" :possible-values="tiposAvaliacao"/>
      <a7-unidade-negocio-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroUnidadeNegocio')"
        property-name="unidadeNegocio"/>
      <a7-classificacao-indicador-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroTipoGestao')"
        property-name="tipoGestao" :tipo="classificacaoIndicadorConstants.TIPO_GESTAO"/>
      <a7-classificacao-indicador-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroDepartamento')"
        property-name="departamento" :tipo="classificacaoIndicadorConstants.TIPO_DEPARTAMENTO"/>
      <a7-classificacao-indicador-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroRamoAtividade')"
        property-name="ramoAtividade" :tipo="classificacaoIndicadorConstants.TIPO_RAMOATIVIDADE"/>
      <a7-classificacao-indicador-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroInvestimento')"
        property-name="investimento" :tipo="classificacaoIndicadorConstants.TIPO_INVESTIMENTO"/>
      <gw-text-filter-item
        :display-text="$t('PainelMedicaoIndicador.ui.filtroGrupoClienteAlpha7')"
        property-name="grupoClienteAlpha7"/>
    </gw-filter-band>
  </div>
</template>

<script>
import {
  GwFilterBand,
  GwTextFilterItem,
  GwPossibleValueFilterItem
} from 'guaxinim-web'
import A7UnidadeNegocioFilterItem from
  '../unidadeNegocio/A7UnidadeNegocioFilterItem'
import A7ClassificacaoIndicadorFilterItem from
  '../classificacaoIndicador/A7ClassificacaoIndicadorFilterItem'
import A7IndicadorFilterItem from
  '../indicador/A7IndicadorFilterItem'
import ClassificacaoIndicadorConstants from
  '../classificacaoIndicador/ClassificacaoIndicadorConstants'

import {tiposAvaliacao} from './A7PainelDefaultConfigurations'

export default {
  name: 'a7-painel-parameter',
  components: {
    GwFilterBand,
    GwTextFilterItem,
    GwPossibleValueFilterItem,
    A7UnidadeNegocioFilterItem,
    A7ClassificacaoIndicadorFilterItem,
    A7IndicadorFilterItem,
  },
  data: () => ({
    filterParams: {},
    tiposAvaliacao,
    classificacaoIndicadorConstants: ClassificacaoIndicadorConstants,
  }),
  methods: {
    emitFiltrou(value) {
      this.$emit('filtrou', value)
    }
  },
  watch: {
    filterParams(value) {
      this.emitFiltrou(value)
    }
  }
}
</script>
<style lang="scss" scoped>
@import './A7PainelFormatacao';
.a7-painel-parameter {
  padding: 0px;
  margin: 0px 5px;
  @include lg {
    border: none;
  }
}
</style>
